import Frame from "common/Layout/Frame";
import Weather from "Features/Weather";
import Meta from "Components/Meta";
import { GetServerSideProps } from "next";
import { FC } from "react";
import {
  fetchLayoutData, fetchSectionData,
  fetchTermData,
  fetchWeatherForcast,
  renderPublication,
} from "../../lib";
import { LayoutProps } from "common/Layout/types/Layout.types";
import { setHeaders } from "../common/Utils/headers";

type Props = {
  menus: LayoutProps;
  weather: any;
};

const WeatherPage: FC<Props> = ({ menus, weather }) => {
  return (
    <Frame data={menus}>
      <Meta />
      <Weather weather={weather} />
    </Frame>
  );
};

export default WeatherPage;
export const getServerSideProps: GetServerSideProps = async (context) => {
  const { res, req } = context;
  const publication = renderPublication(context.req);
  const data: any = await fetchSectionData(publication, `?path=weather`);

  // Set the cache tags
  if (data.data.cacheKeys) {
    res.setHeader("Cache-Tag", data.data.cacheKeys.join(", "));
  } else {
    res.setHeader(
      "Cache-Tag",
      `tindle_weather_${process.env.NEXT_PUBLIC_ENV_STATE}, weather_${publication}`,
    );
  }

  // Set Cache-Control header for 3 hours
  res.setHeader(
    'Cache-Control',
    'public, max-age=0, s-maxage=10800, stale-if-error=10800, stale-while-revalidate=3600'
  );
  try {
    const publication = renderPublication(context.req);
    const props = {
      menus: await fetchLayoutData(publication),
      terms: await fetchTermData(publication),
      weather: await fetchWeatherForcast(publication),
      publication,
    };
    return {
      props,
    };
  } catch (err) {
    console.log(err);
  }
  return { props: { data: "err" } };
};
